import React from 'react';
import {Toaster} from '@learningblocks/storybook-components';
import {TestTubeIcon} from '@learningblocks/storybook-components/lib/Icons';

export const NOTIFY_EVENTS = {
  TUBES_REMOVED: {
    title: 'Tube(s) removed too soon!',
    message:
      'The contents of the tube was not incubated long enough to reach the desired temperature.',
    image: TestTubeIcon,
  },
};

export function useHeatblock(props, alert) {
  const alertError = (params) => {
    alert({
      ...NOTIFY_EVENTS.TUBES_REMOVED,
      ...params,
      type: Toaster.Types.WARNING,
    });
  };

  const heatblockWarnings = (callback) => {
    if (props.isHeating) {
      callback();
      alertError(NOTIFY_EVENTS.TUBES_REMOVED);
    } else {
      callback();
    }
  };

  return {
    alertError,
    heatblockWarnings,
  };
}
